// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"d0bbbc63","52":"c7b54c43","125":"f003d601","379":"ee8bd046","498":"8bef3ec0","703":"674d2745","802":"9ee3af87","839":"a7f7cb83","921":"79807a48"}[chunkId] + ".chunk.js";
};